import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

interface PairResponse {
  stationId: string;
  accepted: boolean;
  publishedAt: string;
}

export interface PairResult {
  ok: boolean;
  status?: number;
  accepted?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AgentPrintService {
  private readonly CANONICAL = 38471;
  private readonly RANGE_TO = 38480;
  private readonly PING_TIMEOUT_MS = 1500;

constructor(private http: HttpClient) { }

 async findAgentPort(quick: boolean): Promise<number | null> {

    for (
      let port = this.CANONICAL;
      port <= this.RANGE_TO;
      port++
    ) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), this.PING_TIMEOUT_MS);

      try {
        const response = await fetch(
          `http://127.0.0.1:${port}/autolacprinter/ping`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          continue;
        }

        const info = await response.json();

        if (info?.product === 'AutolacPrinterLocal') {
          return port;
        }

        if (quick) {
          break;
        }
      } catch {
        if (quick) {
          break;
        }
      }
      finally {
        clearTimeout(timer);
      }
    }

    return null;
  }

  async pair(
    port: number,
    operatorObjectId: string
  ): Promise<PairResult> {
    if (!operatorObjectId) {
      return { ok: false };
    }

    try {
      const response = await firstValueFrom(
        this.http.post<PairResponse>(
          `http://127.0.0.1:${port}/autolacprinter/pair`,
          {
            operatorObjectId
          },
          { observe: 'response' }
        )
      );

      const accepted = response.body?.accepted === true;
      return { ok: accepted, status: response.status, accepted };
    } catch (error) {
      const status = error instanceof HttpErrorResponse ? error.status : undefined;
      return { ok: false, status };
    }
  }
}
